import { PlainFontFamily } from "@/lib/gql/__generated__/graphql";

/**
 *
 * @description Tailwind で定義している FontFamily の ClassName へのマッピング
 *
 * @see {@path src/styles/tailwind-config-presets.ts}
 *
 */
export const PlainFontFamilyClassNames: { [key: PlainFontFamily[number]]: string } = {
	[PlainFontFamily.KleeOne]: "Klee One, cursive",
	[PlainFontFamily.NotoSansJp]: "Noto Sans JP, sans-serif",
	[PlainFontFamily.ShipporiMincho]: "Shippori Mincho, serif",
};

/**
 *
 * @description PlainFontFamily の表記名
 *
 */
export const PlainFontFamilyNames: { [key: PlainFontFamily[number]]: string } = {
	[PlainFontFamily.KleeOne]: "Klee One",
	[PlainFontFamily.NotoSansJp]: "Noto Sans JP",
	[PlainFontFamily.ShipporiMincho]: "Shippori Mincho",
};
